module.exports = __webpack_public_path__ + "media/images/red-downward-arrow-12470904e9ebe98ac82aba3c9605d3bd.png";